import { Pipe, PipeTransform } from '@angular/core';
import { MemberDto } from '@careapp-group/ng-sdk';

@Pipe({
    name: 'memberExternalId',
    standalone: false
})
export class MemberExternalIdPipe implements PipeTransform {
  transform(value: MemberDto) {
    if (!value) {
      return;
    }
    if (!value.permissions || !value.permissions.length) {
      return;
    }

    // Join all distinct
    return Array.from(
      new Set(
        value.permissions
          .filter((permission) => !!permission.externalId && !!permission.externalId.length)
          .map((permission) => permission.externalId)
      )
    ).join(', ');
  }
}
